import CRUDService from './CRUDService';

export default new CRUDService('notifications');
